import toList from "../utils/ComponentUtil";
import CheckList from '../../images/browse-jobs/icon-park-solid_correct.png';

function PointsCard({ title, subTitle, points }) {
  return (
    <div className="duties">
      <div className="title">{title}</div>
      <div className="experiences-wrp">
        <div className="duties-title">{subTitle}</div>
        <div className="all-duties">
          {toList(points, undefined, (item, i) => (
            <div className="duty-wrp" key={i}>
              <img src={CheckList} alt="duty" />
              <div className="content">{item}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PointsCard;
